import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isDesktopDropdownOpen, setDesktopDropdownOpen] = useState(false);
  const [isMobileDropdownOpen, setMobileDropdownOpen] = useState(false);

  const desktopDropdownRef = useRef(null);

  // Handle outside click for desktop dropdown
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        desktopDropdownRef.current &&
        !desktopDropdownRef.current.contains(event.target)
      ) {
        setDesktopDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <nav className="bg-gradient-to-r from-indigo-900 to-indigo-900 text-white px-6 py-4 shadow-md sticky top-0 z-50">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo Section */}
        <div className="text-2xl font-bold flex items-center space-x-2">
          <span className="bg-white text-indigo-900 p-2 rounded-full">JM</span>
          <span>Job Market</span>
        </div>

        {/* Desktop Navigation Links */}
        <ul className="hidden md:flex space-x-6">
          <li>
            <Link to="/" className="navbar-link">
              Home
            </Link>
          </li>
          <li className="relative" ref={desktopDropdownRef}>
            <button
              className="navbar-link focus:outline-none"
              onClick={() =>
                setDesktopDropdownOpen((prev) => !prev)
              }
            >
              Signup
            </button>
            {isDesktopDropdownOpen && (
              <ul className="absolute left-0 bg-white text-black shadow-md">
                <li>
                  <Link
                    to="/regemp"
                    className="block px-4 py-2 hover:bg-gray-100"
                  >
                    Un-Employed
                  </Link>
                </li>
                <li>
                  <Link
                    to="/company_registration"
                    className="block px-4 py-2 hover:bg-gray-100"
                  >
                    Company
                  </Link>
                </li>
              </ul>
            )}
          </li>
          
          <li>
            <Link to="/login" className="navbar-link">
              Login
            </Link>
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden flex flex-col items-center space-y-1 focus:outline-none"
          onClick={() => setMobileMenuOpen((prev) => !prev)}
        >
          <span className="block w-6 h-0.5 bg-white"></span>
          <span className="block w-6 h-0.5 bg-white"></span>
          <span className="block w-6 h-0.5 bg-white"></span>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="flex flex-col bg-purple-700 text-white md:hidden transition-all duration-300 ease-in-out transform">
          <Link to="/" className="navbar-link" onClick={() => setMobileMenuOpen(false)}>
            Home
          </Link>

          {/* Mobile Signup Dropdown */}
          <div className="relative">
            <button
              className="navbar-link w-full text-left"
              onClick={() =>
                setMobileDropdownOpen((prev) => !prev)
              }
            >
              Signup
            </button>
            {isMobileDropdownOpen && (
              <ul className="bg-purple-700 text-white w-full">
                <li>
                  <Link
                    to="/regemp"
                    className="block py-2 px-4 hover:bg-purple-600 hover:text-yellow-300"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Student
                  </Link>
                </li>
                <li>
                  <Link
                    to="/company_registration"
                    className="block py-2 px-4 hover:bg-purple-600 hover:text-yellow-300"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Company
                  </Link>
                </li>
              </ul>
            )}
          </div>

          
          <Link
            to="/login"
            className="navbar-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Login
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
